import en from "./en";
import sv from "./sv";
import da from "./da";
import nl from "./nl";
import fi from "./fi";
import de from "./de";
import th from "./th";
import ar from "./ar";
import fr from "./fr";
import no from "./no";

function language(locale, textsoverride) {
  var languages = {
    en: en,
    sv: sv,
    da: da,
    nl: nl,
    fi: fi,
    de: de,
    th: th,
    ar: ar,
    fr: fr,
    no: no,
  };

  if (textsoverride && Object.keys(textsoverride).length > 0) {
    for (var language in languages) {
      if (textsoverride.hasOwnProperty(language)) {
        if (!languages[language]) {
          languages[language] = {};
        }
        languages[language] = {
          ...languages[language],
          ...textsoverride[language],
        };
      } else {
        delete languages[language];
      }
    }
  }

  if (Object.keys(languages).indexOf(locale) === -1) {
    locale = Object.keys(languages)[0];
  }

  return {
    texts: languages,
    text: text(languages[locale]),
    locale: locale,
  };
}

function text(translations) {
  return (str, fallback = null) => {
    var ret = translations[str];

    if (!ret && fallback) {
      ret = translations[fallback];
    }

    if (!ret) {
      console.debug(`translation missing for "${str}"`);
      ret = "?" + str;
    }

    return ret;
  };
}

export default language;



// WEBPACK FOOTER //
// ./src/branding/default/language/language.js